import { i18n } from '@/main'

const helpers = {
  /**
   * Used to convert payload from the API to our form values
   */
  conversionHelper: object => {
    const converted = {}
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (object[key] && object[key].id && typeof object[key] === 'object') {
          converted[`${key}_id`] = object[key].id
        }
        converted[key] = object[key]
      }
    }
    return converted
  },

  /**
   * Password validation (length checking)
   */
  passwordValidator: (rule, value, callback) => {
    if (!value) {
      callback(new Error(i18n.t('forms.validation.invalidPassword')))
    } else if (value.length < 6) {
      callback(new Error(i18n.t('forms.validation.passwordMinLength')))
    } else {
      callback()
    }
  },

  /**
   * Password validation (same value & length)
   */
  newPasswordValidator: (rule, value, callback) => {
    if (!value) {
      callback(new Error(i18n.t('forms.validation.invalidNewPassword')))
    } else if (value.length < 6) {
      callback(new Error(i18n.t('forms.validation.passwordMinLength')))
    } else {
      callback()
    }
  },

  /**
   * Record status helper to parse records by the frontend status values
   */
  recordStatusMapper: (record, status) => {
    switch (status) {
      case 'all':
        return true
      case 'ongoing':
        return (
          [
            'created',
            'pending',
            'processing_missing_documents',
            'processing_missing_guarantors',
            'processing_added_documents',
            'processing_added_guarantors',
            'granted_waiting_accommodation',
            'granted_waiting_price_acceptation',
            'granted_accepted',
            'granted_waiting_digital_signature',
            'granted_digitaly_signed',
            'granted_waiting_physical_signature',
            'granted_physically_signed'
          ].indexOf(record.state) > -1
        )
      case 'done':
        return record.state === 'finished'
      case 'refused':
        return (
          [
            'refused_application_canceled',
            'refused_accommodation_declined',
            'refused',
            'refused_incomplete',
            'refused_wrong_information',
            'refused_renter_withdrawal',
            'refused_digital_signature_expired',
            'refused_physical_signature_expired'
          ].indexOf(record.state) > -1
        )
    }
  }
}

export default {
  install(Vue) {
    Vue.prototype.$helpers = helpers
    Vue.$helpers = helpers
  }
}
